/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Nothing_Selected_ErrorInputs */



/**
* | output |
* | --- |
* | "Select at least one subtitle track to publish, publish markers, or request a review." |
*
* @param {Iconik_Publish_Nothing_Selected_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_nothing_selected_error = /** @type {((inputs?: Iconik_Publish_Nothing_Selected_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Nothing_Selected_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
	return /** @type {LocalizedString} */ ("Select at least one subtitle track to publish, publish markers, or request a review.")
});